<section class="members-table-pagination-info">
    <span class="members-table-pagination-info__text">
        Showing
        <span class="members-table-pagination-info__text--highlight">
            {{ itemsPerPage | paginationInfo: currentPageNumber : itemsTotalCount }}
        </span>
        of
        <span class="members-table-pagination-info__text--highlight">{{ itemsTotalCount }}</span>
        entries
    </span>
</section>
